module.exports = __webpack_public_path__ + "static/media/ic_print.c253b084.svg";